import { render, staticRenderFns } from "./UserInfos.vue?vue&type=template&id=dffd8dea&scoped=true&"
import script from "./UserInfos.vue?vue&type=script&lang=js&"
export * from "./UserInfos.vue?vue&type=script&lang=js&"
import style0 from "./UserInfos.vue?vue&type=style&index=0&id=dffd8dea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffd8dea",
  null
  
)

export default component.exports